"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDataExplorerFilters = mapDataExplorerFilters;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _filters = require("../util/filters");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var crossCompatibleFilters = ['i_device_id', 'i_device_label', 'i_device_name', 'i_device_site_id', 'i_device_site_name', 'i_device_subtype', 'i_device_type', 'i_input|output_interface_description', 'i_input|output_interface_group', 'i_input|output_snmp_alias', 'inet_src|dst_addr'];
var filterMappings = {
  i_device_name: 'device_name',
  'i_input|output_interface_description': 'name',
  'i_input|output_snmp_alias': 'description',
  'inet_src|dst_addr': 'device_ip'
};
var filterMeasurementConstraints = {
  'i_input|output_interface_description': function i_inputOutput_interface_description(model) {
    return model.measurement.startsWith('/interfaces/');
  },
  'i_input|output_snmp_alias': function i_inputOutput_snmp_alias(model) {
    return model.measurement.startsWith('/interfaces/');
  }
};

/**
 * Finds a dimension in the measurement model that has a QueryColumn matching the filter's filterField.
 * This is used as a fallback to map filters that aren't in the allowedFilters list but can still be mapped to dimensions based on their QueryColumn,
 * which allows for more flexible filtering without needing to explicitly support every possible filter field.
 *
 * @param filter {FilterObj} - the filter to find a matching dimension for
 * @param measurementModel {MeasurementModel} - the measurement model to search for dimensions in
 * @returns {string | null} the name of the dimension with a QueryColumn matching the filter field, or null if no match is found
 */
var findDimWithMatchingQueryColumn = function findDimWithMatchingQueryColumn(filter, measurementModel) {
  var _Object$entries$find$, _Object$entries$find;
  var _ref = measurementModel.storage || {},
    _ref$Dimensions = _ref.Dimensions,
    Dimensions = _ref$Dimensions === void 0 ? {} : _ref$Dimensions;
  if ((0, _isEmpty2["default"])(Dimensions)) {
    return null;
  }
  return (_Object$entries$find$ = (_Object$entries$find = Object.entries(Dimensions).find(function (_ref2) {
    var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
      _ = _ref3[0],
      dim = _ref3[1];
    return dim.QueryColumn === filter.filterField;
  })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[0]) !== null && _Object$entries$find$ !== void 0 ? _Object$entries$find$ : null;
};

/**
 * Metric Explorer queries will break if we try to filter by unsupported dimensions.
 * This function ensure that we only include filters that can be mapped to dimensions in the measurement model,
 * either through explicit mappings for known filter fields or by matching filter fields to dimension QueryColumns.
 *
 * Maps Metrics Explorer dimensions to Data Explorer dimensions in filters,
 * and also allows for mapping based on matching QueryColumns as a fallback.
 * If an appropriate filter cannot be found or mapped, it is removed from the filters list.
 *
 * @param dataExplorerFilters
 * @param kmetricsMeasurementModel
 */
function mapDataExplorerFilters(dataExplorerFilters, kmetricsMeasurementModel) {
  var _ref4 = kmetricsMeasurementModel.storage || {},
    _ref4$Dimensions = _ref4.Dimensions,
    Dimensions = _ref4$Dimensions === void 0 ? {} : _ref4$Dimensions;
  return (0, _filters.mapFilters)(dataExplorerFilters, function (filter) {
    if (crossCompatibleFilters.includes(filter.filterField)) {
      var mapping = filterMappings[filter.filterField];
      var constraint = filterMeasurementConstraints[filter.filterField];
      if (constraint && !constraint(kmetricsMeasurementModel)) {
        // filter can't be used here
        return null;
      }
      if (!mapping) {
        // no transformation needed
        return filter;
      }
      if (Dimensions[mapping]) {
        return _objectSpread(_objectSpread({}, filter), {}, {
          filterField: mapping
        });
      }
    }
    if (filter.filterField in Dimensions) {
      // filter is already mapped to a dimension and is therefore compatible, so we can use it as is
      return filter;
    }

    // try to find a dimension with a matching QueryColumn as a fallback mapping option
    var dimWithMatchingQueryColumn = findDimWithMatchingQueryColumn(filter, kmetricsMeasurementModel);
    if (dimWithMatchingQueryColumn) {
      // filter field matches a dimension query column, so we can map it
      return _objectSpread(_objectSpread({}, filter), {}, {
        filterField: dimWithMatchingQueryColumn
      });
    }

    // filter can't be mapped
    return null;
  });
}